import React, { useState } from 'react';
import { Row, Col, Tab, Nav, Button } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import { useHistory } from 'react-router-dom';
import { AbilityContext } from '../../config/abilityContext';
import { Icon, SimpleCenteredModal } from '../../components';
import { useSetTab } from '../../services/hooks';
import ConceptsIndex from '../Concepts/ConceptsIndex';
import PreloadedConcepts from '../Concepts/PreloadedConcepts';
import { sendAlert } from '../../actions/utils';
import BookkeeperDocumentTypeIndex from '../BookkeeperDocumentType/BookkeeperDocumentTypeIndex';
import BookkeeperDocumentTypeForm from '../BookkeeperDocumentType/BookkeeperDocumentTypeForm';
import basicBookkeeperDocumentType from '../BookkeeperDocumentType/bookkeeperDocumentType';
import { createBookkeeperDocumentTypeRequest } from '../../requests/bookkeepersDocumentTypes';
import BookkeeperIndex from '../Bookkeeper/BookkeeperIndex';
import SettlementSettingsIndex from '../SettlementSettings/SettlementSettingsIndex';

const RemunerationsSettings = ({ location }) => {
  const [moreData, setMoreData] = useState(false);
  const ability = useAbility(AbilityContext);
  const remunerationPermissions = [
    ability.can('read_concept', 'Balance'),
    ability.can('index', 'Bookkeeper'),
    ability.can('index', 'BookkeeperDocumentType')
  ];

  const [modalBookkeeperShow, setModalBookkeeperShow] = useState(false);
  const [modalSize, setModalSize] = useState('lg');
  const [modalBody, setModalBody] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const dispatch = useDispatch();
  const history = useHistory();

  let defaultTab = '';

  if (remunerationPermissions[0]) {
    defaultTab = 'concepts-tab';
  } else if (remunerationPermissions[1]) {
    defaultTab = 'bookkeepers';
  } else {
    defaultTab = 'bookkeeper_document_types';
  }

  const [key, setKey] = useSetTab(defaultTab, location);

  const handleSuccess = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    setModalBookkeeperShow(false);
    setMoreData(!moreData);
  };

  const handleCreateBookkeeperDocumentType = (bookkeeperDocumentTypeValue, setSubmitting) => {
    createBookkeeperDocumentTypeRequest({
      dispatch,
      params: snakeCaseKeys(bookkeeperDocumentTypeValue),
      formData: true,
      successCallback: () => handleSuccess('Tipo de Documento creado con éxito'),
      callback: () => setSubmitting(false)
    });
  };

  const newBookkeeperDocumentType = () => {
    setModalTitle('Nuevo Tipo de Documento');
    setModalSize('md');
    setModalBookkeeperShow(true);
    setModalBody(
      <BookkeeperDocumentTypeForm
        bookkeeperDocumentType={basicBookkeeperDocumentType}
        action="new"
        formRequest={handleCreateBookkeeperDocumentType}
        cancelAction={() => setModalBookkeeperShow(false)}
      />
    );

    return null;
  };

  const handleClick = () => {
    switch (key) {
      case 'concepts-tab':
        history.push(`/remunerations_settings/new`);
        break;
      case 'bookkeeper_document_types':
        return newBookkeeperDocumentType();
      case 'bookkeepers':
        history.push('/remunerations_settings/new_bookkeeper');
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Error: Action not found');
        return '';
    }
    return null;
  };

  return (
    <>
      <Row className="mt-4 mb-2">
        <Col>
          <h2 className="mb-3 mt-3">Configuraciones</h2>
        </Col>
        <Col md={3}>
          {key !== 'preloaded-concepts-tab' && (
            <Button variant="primary" block onClick={handleClick}>
              Nuevo
            </Button>
          )}
        </Col>
      </Row>
      <Tab.Container id="company-settings-index.tabs" activeKey={key} onSelect={k => setKey(k)} mountOnEnter>
        <Nav variant="pills">
          {ability.can('read_concept', 'Balance') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="concepts-tab">
                <Icon icon="cube" />
                Mantenedor de conceptos
              </Nav.Link>
            </Nav.Item>
          )}
          {ability.can('read_concept', 'Balance') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="preloaded-concepts-tab">
                <Icon icon="cube" />
                Conceptos Precargados
              </Nav.Link>
            </Nav.Item>
          )}

          {ability.can('index', 'BookkeeperDocumentType') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="bookkeeper_document_types">
                <Icon icon="location" />
                Tipo de Doc. Contables
              </Nav.Link>
            </Nav.Item>
          )}
          {ability.can('index', 'Bookkeeper') && (
            <Nav.Item>
              <Nav.Link className="mb-1" eventKey="bookkeepers">
                <Icon icon="albums" />
                Cuentas Contables
              </Nav.Link>
            </Nav.Item>
          )}
          {/*           <Nav.Item>
            <Nav.Link className="mb-1" eventKey="settlement-settings-tab">
              <Icon icon="albums" />
              Simulador de Finiquitos
            </Nav.Link>
          </Nav.Item> */}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="concepts-tab">
            <ConceptsIndex moreData={moreData} setMoreData={setMoreData} />
          </Tab.Pane>
          <Tab.Pane eventKey="preloaded-concepts-tab">
            <PreloadedConcepts moreData={moreData} setMoreData={setMoreData} />
          </Tab.Pane>
          {ability.can('index', 'BookkeeperDocumentType') && (
            <Tab.Pane eventKey="bookkeeper_document_types">
              <BookkeeperDocumentTypeIndex moreData={moreData} setMoreData={setMoreData} />
            </Tab.Pane>
          )}
          {ability.can('index', 'Bookkeeper') && (
            <Tab.Pane eventKey="bookkeepers">
              <BookkeeperIndex moreData={moreData} setMoreData={setMoreData} />
            </Tab.Pane>
          )}
          <Tab.Pane eventKey="settlement-settings-tab">
            <SettlementSettingsIndex moreData={moreData} setMoreData={setMoreData} />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
      <SimpleCenteredModal
        title={modalTitle}
        body={modalBody}
        show={modalBookkeeperShow}
        onHide={() => setModalBookkeeperShow(false)}
        size={modalSize}
      />
    </>
  );
};

export default RemunerationsSettings;
